module.exports = new __parcel__URL__("give_food_button.bc490c9f.png").toString();